export enum XEnum {
  tweets_of_last_seven_days = 'tweets_of_last_seven_days',
  tweets_of_user = 'tweets_of_user',
  tweet_informations = 'tweet_informations',
  tweets_popular_count = 'tweets_popular_count',
  retweet_informations = 'retweet_informations',
  tweet_like_count = 'tweet_like_count',
  // user_informations = 'user_informations',
}
